export default "__VITE_ASSET__8a55a4db__"